import React, { useCallback, useEffect, useRef, useState } from "react";

import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { isValidPhoneNumber } from "react-phone-number-input";

import ApartmentIcon from "@mui/icons-material/Apartment";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Autocomplete as Pracel,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import LoanProgram from "./LoanProgram";
import { Loader } from "../common/loader";
import CallUsNow from "../common/CallUsNow";
import DialogBox from "../common/DialogBox";
import mail from "../../assets/icons/mail.png";
import AlertDialog from "../common/AlertDialog";
import Success from "../../assets/icons/success.png";
import ContactSupport from "../common/ContactSupport";
import CustomTextField from "../common/CustomTextField";
import account from "../../assets/icons/account_circle.png";
import Facebook_Icon from "../../assets/articles/facebook.svg";
import { LoaderWithTimeout } from "../common/LoaderWithTimeout";
import RiskAssesmentLoader from "../common/RiskAssesmentLoader";
import Instagram_Icon from "../../assets/articles/instagram.svg";
import CustomPhoneNumberInput from "../common/CustomPhoneNumberInput";
import { userSigupAction } from "../../redux/slices/user/userSignUpSlice";
import HubspotCookieBreakerInput from "../common/HubspotCookieBreakerInput";
import { useContactPopover } from "../common/useContactPopover";
import CustomizedCheckbox from "../common/customDesignedComponents/customCheckbox";
import PropertyRiskManagementFormTailwind from "./PropertyRiskManagementFormTailwind";
import PropertyLocateRecoveryDialog from "./PropertyLocateRecoveryDialog";
import { propertyRiskManagementAction } from "../../redux/slices/admin/property-risk-management/propertyRiskManagementSlice";
import {
  encryptPayload,
  getAddressFromGoogleAutoComplete,
  getObjLength,
  getShortNameAddressFromGoogleAutoComplete,
  normalizePropertySearchPayload,
  propertyRiskReportDataObj,
} from "../helpers/utils";
import {
  DEFAULT_URL,
  FACEBOOK_LINK,
  FieldStyle,
  GOOGLE_API_KEY,
  INSTAGRAM_LINK,
  MARKETING_AUTOMATION_ID,
  SEARCH_PROPERTY_ADDRESS_FORMAT,
  SERVER,
  UCC_FILLER_PHONE_FORMAT,
} from "../helpers/constants";

import "./PropertyRiskManagement.scss";
import "../../styles/landingpage.scss";
import "../../styles/howItWorksSection.scss";

export const normalizeParcelNumber = (value) =>
  String(value ?? "").replace(/[\s-]+/g, "");

export const propertyRiskFormValidations = (type, isValid) => {
  // Messages name the field the way it is labelled ("Your Name" or "Client's Name").
  const nameLabel = isValid?.nameLabel || "Your Name";
  return Yup.object().shape({
    name: isValid?.name
      ? Yup.string("Please enter your First Name.")
          .trim(`${nameLabel} cannot include leading and trailing spaces`)
          .strict(true)
          .min(2, "Too Short!")
          .max(50, "Too Long!")
          .required(`${nameLabel} is required`)
      : Yup.string(),
    address:
      type === "address"
        ? Yup.string("Please enter your Address.")
            .trim("The Address cannot include leading and trailing spaces")
            .strict(true)
            .min(5, "Too Short!")
            .max(100, "Too Long!")
            .required("Address is required")
        : Yup.string(),
    parcel_number:
      type === "parcel"
        ? Yup.string().required("Parcel number is required")
        : Yup.string(),
    county_code:
      type === "parcel"
        ? Yup.string("Please select the County ").required(
            "County  is required",
          )
        : Yup.number(),

    email: Yup.string("Please enter your Email Id.")
      .email("Invalid email format")
      .max(255)
      .required("Email id is required"),
    phone: Yup.string("Please enter your Phone number.")
      .typeError("That doesn't look like a phone number")
      // .positive()
      .required("Mobile number is required"),
  });
};

// Google place details a submitted address search carried (see handleChange).
const SAVED_ADDRESS_DETAIL_KEYS = [
  "searched_Add",
  "street_number",
  "site_route",
  "country",
  "latitude",
  "longitude",
  "city",
  "county",
  "state_name",
  "state",
  "zip",
];

const pickSavedAddressDetails = (saved = {}) =>
  SAVED_ADDRESS_DETAIL_KEYS.reduce((details, key) => {
    if (saved[key] !== undefined) {
      details[key] = saved[key];
    }
    return details;
  }, {});

const PropertyRiskManagementForm = ({
  is_PRM = true,
  setGetFreeReport = () => {},
  getFreeReport,
  county_id = undefined,
  widthClass,
  source = null,
  host_path = null,
  host_promocode = undefined,
  AUTOMATION_ID = MARKETING_AUTOMATION_ID,
  isAdmin = false,
  setIsRiskReport = () => {},
  adminRiskAssessmentUrl = null,
  adminAssessmentMeta = null,
  adminAssessmentBlocked = false,
  isRiskAssessment = false,
  prefix_route = undefined,
  broker = undefined,
  formParams = {},
  isBackButton = false,
  setIsRiskFormVisible = () => {},
  acknowledgeMsg = undefined,
  Btn_Text = "Get Your Free Report",
  isGetFreeReportAlert = false,
  setIsFreeMonitoringAlert = () => {},
  setFormData = () => {},
  isTailwindComponent = false,
  hideSearchTypeDropdown = false,
  // Two-column card layout for the homepage hero (Tailwind form only)
  isCompactLayout = false,
}) => {
  const isCustomerServiceForm = isAdmin || Boolean(adminRiskAssessmentUrl);
  const isAdminHubAssessment = Boolean(adminRiskAssessmentUrl);
  const isNewPurchaseAssessment =
    adminAssessmentMeta?.assessment_type === "new_purchase";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // store data
  const {
    riskManagementData,
    riskManagementLoader,
    propertyLoanAmountData,
    riskManagementPayload,
  } = useSelector((state) => state?.propertyRiskManagement);

  const { loaded } = useSelector((state) => state?.autocomplete);
  const { countyList, statesLoader, getRiskReportDetails, userLoginLoader } =
    useSelector((state) => state.signUpUser);

  // const loaded = useGoogleMapsScript(GOOGLE_API_KEY);
  // console.log("loaded==>", loaded);
  const [checkTerms, setCheckTerms] = useState(true); //set it true coz hide the checkTerms
  const [checked1, setChecked1] = useState(isAdmin);
  const [onSubmitClick, setOnSubmitClick] = useState(false);
  const [callScript, setCallScript] = useState(false);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  // formParams can be a search the visitor already ran (county free site, back from
  // an error popup): reopen it as it was, with the picked address's details.
  const [propertyData, setPropertyData] = useState(() =>
    formParams?.type === "address" && formParams?.searched_Add
      ? pickSavedAddressDetails(formParams)
      : {},
  );
  const [value, setValue] = useState(
    formParams?.type === "parcel" ? "parcel" : "address",
  );
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [countyInput, setCountyInput] = useState(
    formParams?.type === "parcel" ? formParams?.county_name || "" : "",
  );
  const [countySearchPending, setCountySearchPending] = useState(false);

  const [isFormLoaded, setIsFormLoaded] = useState(false);
  const [propertyLoanAmount, setPropertyLoanAmount] = useState(false);
  const formRef = useRef(null);
  const countyDebounceRef = useRef(null);
  const COUNTY_SEARCH_DEBOUNCE_MS = 400;
  const isCountySearching = countySearchPending || statesLoader;
  const { handleClick, ContactPopover } = useContactPopover();

  // Create URL object
  const parsedUrl = new URL(window?.location?.href);
  const params = new URLSearchParams(parsedUrl?.search);
  // Extract tokens
  const reportToken = params.get("report_token");
  const resendToken = params.get("resend_token");

  // const handleChange = (place) => {
  //   var address = place.formatted_address;
  //   console.log("Place values==?>", place);
  //   var value = address?.split(",");
  //   const count = value.length;
  //   const stateVal = value[count - 2];

  //   var stateSplit = stateVal?.split(" ");

  //   const state = stateSplit[1];

  //   let param = {
  //     address: address,
  //     state: state,
  //   };

  //   console.log(value, "map lag==>>", param);
  // };

  const onCheckedTerms = (e) => {
    console.log("checked val==>", e.target.checked);
    setCheckTerms(e.target.checked);
  };

  const onCheckedAcknowledge = (e) => {
    console.log("checked val==>", e.target.checked);
    setChecked1(e.target.checked);
  };

  const runAnotherReport = (values) => {
    dispatch(propertyRiskManagementAction.fetchPropertyRiskManagementData({}));
    setIsFormSubmit(false);
    //  setCheckTerms(false);
    setChecked1(isAdmin);
  };

  const handlePropertyLoanAmountModal = useCallback(() => {
    setPropertyLoanAmount(false);
    dispatch(
      propertyRiskManagementAction.clearPropertyRiskManagementPayload({}),
    );
    dispatch(propertyRiskManagementAction.fetchPropertyLoanAmountData({}));
  }, [dispatch]);

  const generateRiskReport = useCallback(
    (updated_loan_amount) => {
      setPropertyLoanAmount(false);
      let data = {
        ...riskManagementPayload,
        risk_report_id: propertyLoanAmountData?.data?.id,
        updated_loan_amount,
        from_risk_form: 1,
      };
      delete data?.get_finance_details;
      dispatch(
        propertyRiskManagementAction.propertyRiskManagementData({
          url: adminRiskAssessmentUrl || `risk-level`,
          data: {
            ...data,
            ...(adminAssessmentMeta || {}),
            ...(adminRiskAssessmentUrl ? { confirm_if_protected: 1 } : {}),
          },
        }),
      );
    },
    [
      adminAssessmentMeta,
      adminRiskAssessmentUrl,
      dispatch,
      propertyLoanAmountData?.data?.id,
      riskManagementPayload,
    ],
  );

  const submitNewPurchaseAssessment = (payload) => {
    const purchaseDetails = adminAssessmentMeta?.purchase_details || {};
    const purchaseLoan = purchaseDetails.is_financing
      ? Number(purchaseDetails.loan_amount || 0)
      : 0;

    dispatch(
      propertyRiskManagementAction.propertyRiskManagementData({
        url: adminRiskAssessmentUrl || `risk-level`,
        data: {
          ...payload,
          ...(adminAssessmentMeta || {}),
          purchase_price_override: Number(purchaseDetails.purchase_price || 0),
          updated_loan_amount: purchaseLoan,
          ...(adminRiskAssessmentUrl ? { confirm_if_protected: 1 } : {}),
          from_risk_form: 1,
        },
      }),
    );
  };

  const loanProtectionConfirmation = propertyLoanAmountData?.data?.errors
    ?.requires_protection_confirmation
    ? propertyLoanAmountData.data.errors
    : null;
  const reportProtectionConfirmation = riskManagementData?.data?.errors
    ?.requires_protection_confirmation
    ? riskManagementData.data.errors
    : null;
  const protectionConfirmation =
    loanProtectionConfirmation || reportProtectionConfirmation;

  const cancelProtectedAssessment = () => {
    dispatch(propertyRiskManagementAction.fetchPropertyRiskManagementData({}));
    dispatch(propertyRiskManagementAction.fetchPropertyLoanAmountData({}));
  };

  const proceedWithProtectedAssessment = () => {
    const data = { ...riskManagementPayload, proceed_if_protected: 1 };
    // The loan lookup is the first request, so continuing it still lets the agent
    // confirm the loan before the report is saved. A later 409 is the report itself.
    if (loanProtectionConfirmation) {
      dispatch(
        propertyRiskManagementAction.getPropertyLoanAmountData({
          url: adminRiskAssessmentUrl,
          data,
        }),
      );
      return;
    }
    dispatch(
      propertyRiskManagementAction.propertyRiskManagementData({
        url: adminRiskAssessmentUrl,
        data,
      }),
    );
  };

  const clearLocateErrorAndFocus = () => {
    const errorCode =
      propertyLoanAmountData?.errors?.error_code ||
      propertyLoanAmountData?.data?.error_code;
    dispatch(propertyRiskManagementAction.fetchPropertyLoanAmountData({}));
    window.setTimeout(() => {
      const focusName =
        errorCode === "unit_required" || value === "address"
          ? errorCode === "unit_required"
            ? "unit_no"
            : "address"
          : "parcel_number";
      const field = document.querySelector(`[name="${focusName}"]`);
      if (field && typeof field.focus === "function") {
        field.focus();
        field.scrollIntoView?.({ behavior: "smooth", block: "center" });
      }
    }, 50);
  };

  const onSubmit = (values) => {
    let payload = {
      ...values,
      ...propertyData,
      type: value,
      hh_uid: formParams?.hh_uid,
    };
    if (getObjLength(propertyData)) {
      let searched_address = {
        full_address: propertyData?.searched_Add,
        param: {
          street_number: propertyData?.street_number,
          site_route: propertyData?.site_route,
          city: propertyData?.city,
          state: propertyData?.state,
          zip: propertyData?.zip,
          unit_no: propertyData?.units,
          county: propertyData?.county,
        },
        fixParams: {
          country: propertyData?.country,
          latitude: propertyData?.latitude,
          longitude: propertyData?.longitude,
          address: propertyData?.streetAdd,
        },
      };
      localStorage.setItem(
        "searched_address",
        JSON.stringify(searched_address),
      );
    }

    if (value === "address") {
      delete payload?.county_code;
      delete payload?.parcel_number;
      payload = normalizePropertySearchPayload(payload);
    } else {
      delete payload?.address;
      delete payload?.city;
      delete payload?.state;
      delete payload?.zip;
      payload.parcel_number = normalizeParcelNumber(payload.parcel_number);
    }
    // Marks reports run through a risk-assessment form (vs. properties added from an
    // account or at signup) so the admin Risk Assessments hub can tell them apart.
    payload.from_risk_form = 1;
    console.log(value, "values==>>", payload);
    if (adminRiskAssessmentUrl && adminAssessmentBlocked) {
      setOnSubmitClick(true);
      return;
    }
    if (checked1 && checkTerms) {
      if (getFreeReport) {
        if (adminRiskAssessmentUrl && isNewPurchaseAssessment) {
          payload = {
            ...payload,
            ...(adminAssessmentMeta || {}),
          };
          submitNewPurchaseAssessment(payload);
          setOnSubmitClick(false);
          setCallScript(false);
          return;
        }
        if (adminRiskAssessmentUrl) {
          payload = {
            ...payload,
            ...(adminAssessmentMeta || {}),
            get_finance_details: isGetFreeReportAlert ? undefined : 1,
          };
        } else {
          payload = {
            ...payload,
            for_county: 1,
            county_id: county_id,
            source: source,
            promocode: host_promocode,
            get_finance_details: isGetFreeReportAlert ? undefined : 1,
          };
        }
        localStorage.setItem(
          "user_details",
          encryptPayload(JSON.stringify(payload)),
        );
      }
      if (isGetFreeReportAlert) {
        setIsFreeMonitoringAlert(true);
        setFormData(payload);
      } else {
        dispatch(
          propertyRiskManagementAction.getPropertyLoanAmountData({
            url: adminRiskAssessmentUrl || `risk-level`,
            data: {
              ...payload,
              ...(adminRiskAssessmentUrl ? { confirm_if_protected: 1 } : {}),
            },
          }),
        );
        setIsFreeMonitoringAlert(false);
      }
      setOnSubmitClick(false);
      if (isAdmin) {
        setCallScript(false);
      } else {
        setCallScript(true);
      }
    } else {
      setOnSubmitClick(true);
      setCallScript(false);
    }
  };

  useEffect(() => {
    console.log("propertyRiskManagement==>", riskManagementData);
    if (getObjLength(riskManagementData) && riskManagementData?.success) {
      console.log("ss nofrom ->", window.__ss_noform);
      // Submit __ss_noform data
      if (SERVER === "production" && callScript && isFormLoaded) {
        window.__ss_noform.push([
          "submit",
          function () {
            return console.log("__ss_noform submitted!");
          },
          AUTOMATION_ID,
        ]);
      }
      if (!getFreeReport) {
        setIsFormSubmit(true);
      } else {
        setGetFreeReport(false);
        if (isAdmin) {
          setIsRiskReport(true);
        } else {
          let route = isTailwindComponent
            ? "/property-risk-report"
            : "/property-risk-report";
          if (prefix_route) {
            route = broker
              ? `/${prefix_route}/${broker}/property-risk-report`
              : `/${prefix_route}/property-risk-report`;
          }
          navigate(route);
        }
        setCallScript(false);
        localStorage.setItem("cc", 1);
        localStorage.setItem("host_path", encryptPayload(host_path));
        if (host_promocode) {
          localStorage.setItem("host_code", encryptPayload(host_promocode));
        }
        if (isRiskAssessment) {
          localStorage.setItem("isRiskAssessment", true);
        }
      }
    } else {
      setIsFormSubmit(false);
    }
  }, [riskManagementData]);

  const getCountyList = (county_value, immediate = false) => {
    const query = String(county_value || "").trim();
    if (!query) {
      return;
    }

    if (countyDebounceRef.current) {
      clearTimeout(countyDebounceRef.current);
      countyDebounceRef.current = null;
    }

    const runSearch = () => {
      dispatch(
        userSigupAction.getCountyList({
          url: "get-county-autocomplete",
          data: { county: query },
        }),
      );
    };

    if (immediate) {
      runSearch();
      return;
    }

    setCountySearchPending(true);
    setOpen(true);
    countyDebounceRef.current = setTimeout(() => {
      countyDebounceRef.current = null;
      // statesLoader covers the request from here. Don't wait for it to flip to
      // true: it may already be true from an earlier search, leaving this stuck.
      setCountySearchPending(false);
      runSearch();
    }, COUNTY_SEARCH_DEBOUNCE_MS);
  };

  const handleCountyInputChange = (event, newInputValue, reason) => {
    if (reason !== "input") {
      return;
    }

    setCountyInput(newInputValue);
    const query = newInputValue.trim();

    if (query.length >= 2) {
      getCountyList(query);
      return;
    }

    setCountySearchPending(false);
    if (query.length === 0) {
      getCountyList("a", true);
    }
  };

  const handleCountyOpen = () => {
    setOpen(true);
    if (!options.length) {
      getCountyList(countyInput.trim() || "a", true);
    }
  };

  useEffect(() => {
    if (statesLoader) {
      setCountySearchPending(false);
    }
  }, [statesLoader]);

  useEffect(() => {
    return () => {
      if (countyDebounceRef.current) {
        clearTimeout(countyDebounceRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (value === "parcel" && !options.length) {
      getCountyList("a", true);
    }
    if (value !== "parcel") {
      setCountyInput("");
    }
  }, [value]);

  useEffect(() => {
    if (getObjLength(countyList)) {
      if (countyList?.success) {
        setOptions([...countyList?.data]);
      }
    }
  }, [countyList]);

  const validationSchema = propertyRiskFormValidations(value, {
    name: true,
    nameLabel: isCustomerServiceForm ? "Client's Name" : "Your Name",
  });

  // Check if the form is in the DOM
  const checkFormLoaded = () => {
    if (formRef?.current) {
      setIsFormLoaded(true);
    } else {
      setTimeout(checkFormLoaded, 100); // Check again after 100ms
    }
  };

  useEffect(() => {
    // Start checking for the form's presence
    checkFormLoaded();

    return () => {
      // Clean up if necessary
    };
  }, []);

  useEffect(() => {
    // Create a <script> element for Lead Gen GTM tags
    if (SERVER === "production" && !isAdmin && isFormLoaded) {
      const form_script = document.createElement("script");
      form_script.type = "text/javascript";
      form_script.innerHTML = `
      var __ss_noform = __ss_noform || [];
      __ss_noform.push([
        "baseURI",
        "https://app-3SCX408CYC.marketingautomation.services/webforms/receivePostback/MzY0MrYwMjEzAQA/"
      ]);
      __ss_noform.push([
        "form",
        "property-risk-form",
      "${AUTOMATION_ID}"
      ]);
      __ss_noform.push(['submitType', 'manual']);
    `;

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://koi-3SCX408CYC.marketingautomation.services/client/noform.js?ver=1.24";

      // Append the <script> element to the document's <body> tag
      const script_loaded = document.querySelector(
        'script[src="https://koi-3SCX408CYC.marketingautomation.services/client/noform.js?ver=1.24"]',
      );
      if (!script_loaded) {
        document.body.appendChild(form_script);
        document.body.appendChild(script);
      }

      // Clean up to remove the <script> element when the component unmounts
      return () => {
        document.body.removeChild(form_script);
        document.body.removeChild(script);
      };
    }

    dispatch(
      propertyRiskManagementAction.clearPropertyRiskManagementPayload({}),
    );
    dispatch(propertyRiskManagementAction.clearPropertyRiskManagementData({}));
    localStorage.removeItem("host_code");
    // localStorage.removeItem("host_path");
  }, [dispatch, isFormLoaded]);

  useEffect(() => {
    if (reportToken) {
      console.log("report_token=-->", reportToken);
      let data = {
        report_id: reportToken,
      };
      if (resendToken) {
        data.resend_token = resendToken;
      }
      dispatch(
        userSigupAction.getRiskReportDetails({
          url: "get-report-details",
          data: data,
        }),
      );
    }
    localStorage.removeItem("category");
  }, []);

  useEffect(() => {
    if (getObjLength(getRiskReportDetails) && getRiskReportDetails?.success) {
      if (reportToken) {
        let property_search_data = propertyRiskReportDataObj(
          getRiskReportDetails?.data,
        );
        console.log(getRiskReportDetails, "property==>", property_search_data);
      }
    }
  }, [getRiskReportDetails]);

  useEffect(() => {
    if (
      getObjLength(propertyLoanAmountData) &&
      propertyLoanAmountData?.success
    ) {
      setPropertyLoanAmount(true);
    } else {
      setPropertyLoanAmount(false);
    }
  }, [propertyLoanAmountData]);

  if (!loaded) {
    // Inside the hero a full-page backdrop would cover the landing page
    return isCompactLayout ? (
      <Box className="d-flex justify-content-center py-5">
        <CircularProgress size={28} />
      </Box>
    ) : (
      <LoaderWithTimeout open={true} />
    );
  }

  return (
    <Box
      className={`box-container bg-white ${
        is_PRM ? "box_shadow text-center" : ""
      } ${widthClass} ${isAdminHubAssessment ? "admin-compact-form admin-hub-risk-form" : ""}`}
    >
      <Box
        className={`${is_PRM ? "request-form" : isAdminHubAssessment ? "" : "property_form_padding"} pb-2 `}
      >
        {!isFormSubmit ? (
          <>
            <Formik
              enableReinitialize
              validateOnChange
              validationSchema={validationSchema}
              initialValues={{
                name:
                  getRiskReportDetails?.data?.name || formParams?.name || "",
                email:
                  getRiskReportDetails?.data?.email || formParams?.email || "",
                phone: (() => {
                  // If phone exists and doesn't start with '+', add '+1'
                  const phone = formParams?.phone || "";
                  if (phone && !phone.startsWith("+")) {
                    return `+1${phone}`;
                  }
                  return phone;
                })(),
                address:
                  getRiskReportDetails?.data?.address_1 ||
                  formParams?.address ||
                  "",
                unit_no: formParams?.unit_no || "",
                parcel_number: formParams?.parcel_number || "",
                county_code: formParams?.county_code || "",
                county_name: formParams?.county_name || "",
              }}
              onSubmit={(values, validation) => {
                if (!isValidPhoneNumber(values?.phone)) {
                  return;
                }
                console.log("vcalues-->>", values);
                onSubmit(values);
              }}
            >
              {({
                values,
                setFieldValue,
                setFieldTouched,
                touched,
                errors,
                isSubmitting,
              }) => {
                // handle selected address for sign up form
                const handleChange = (address) => {
                  console.log("address changed==>", address);
                  const condos = address.address_components.filter((i, k) =>
                    i.types.includes("subpremise"),
                  );
                  var units = condos.length > 0 ? condos[0]?.long_name : "";
                  setFieldValue("unit_no", units);
                  setFieldValue(
                    "address",
                    getShortNameAddressFromGoogleAutoComplete(
                      address,
                      "street_number",
                    ) +
                      (getShortNameAddressFromGoogleAutoComplete(
                        address,
                        "street_number",
                      )
                        ? " "
                        : "") +
                      getShortNameAddressFromGoogleAutoComplete(
                        address,
                        "route",
                      ),
                  );
                  var county = getShortNameAddressFromGoogleAutoComplete(
                    address,
                    "administrative_area_level_2",
                  );
                  var county_name = county?.replace("County", "").trim();
                  let data = {
                    searched_Add: address?.formatted_address,
                    street_number: getAddressFromGoogleAutoComplete(
                      address,
                      "street_number",
                    ),
                    site_route: getAddressFromGoogleAutoComplete(
                      address,
                      "route",
                    ),
                    country: getShortNameAddressFromGoogleAutoComplete(
                      address,
                      "country",
                    ),
                    latitude: address.geometry.location.lat(),
                    longitude: address.geometry.location.lng(),
                    city: getAddressFromGoogleAutoComplete(address, "locality"),
                    county: county_name,
                    state_name: getAddressFromGoogleAutoComplete(
                      address,
                      "administrative_area_level_1",
                    ),
                    state: getShortNameAddressFromGoogleAutoComplete(
                      address,
                      "administrative_area_level_1",
                    ),
                    zip: getAddressFromGoogleAutoComplete(
                      address,
                      "postal_code",
                    ),
                    //unit_no: units,
                  };

                  setPropertyData(data);
                };

                // Render new Tailwind form if isTailwindComponent is true
                if (isTailwindComponent) {
                  return (
                    <PropertyRiskManagementFormTailwind
                      values={values}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      touched={touched}
                      errors={errors}
                      isSubmitting={isSubmitting}
                      formRef={formRef}
                      value={value}
                      setValue={setValue}
                      handleChange={handleChange}
                      setPropertyData={setPropertyData}
                      checked1={checked1}
                      onCheckedAcknowledge={onCheckedAcknowledge}
                      onSubmitClick={onSubmitClick}
                      checkTerms={checkTerms}
                      isAdmin={isAdmin}
                      host_path={host_path}
                      Btn_Text={Btn_Text}
                      isBackButton={isBackButton}
                      setIsRiskFormVisible={setIsRiskFormVisible}
                      acknowledgeMsg={acknowledgeMsg}
                      open={open}
                      setOpen={setOpen}
                      options={options}
                      getCountyList={getCountyList}
                      setOptions={setOptions}
                      statesLoader={isCountySearching}
                      hideSearchTypeDropdown={hideSearchTypeDropdown}
                      isCompactLayout={isCompactLayout}
                    />
                  );
                }

                // Render old form
                return (
                  <>
                    <Form id="property-risk-form" ref={formRef}>
                      {/* Hubspot hidden input for cookie breaker */}
                      <HubspotCookieBreakerInput />

                      <Grid container spacing={isAdminHubAssessment ? 2 : 1.25}>
                        <Grid
                          item
                          xs={12}
                          md={isAdminHubAssessment ? 6 : 12}
                          lg={isAdminHubAssessment ? 6 : isAdmin ? 6 : 12}
                          className={isAdminHubAssessment ? "" : "p-top-down"}
                        >
                          {isAdminHubAssessment ? (
                            <TextField
                              fullWidth
                              size="small"
                              label="Client's Name"
                              name="name"
                              value={values.name ?? ""}
                              onChange={(event) =>
                                setFieldValue("name", event.target.value)
                              }
                              onBlur={() => setFieldTouched("name", true)}
                              error={Boolean(touched.name && errors.name)}
                              helperText={touched.name && errors.name}
                            />
                          ) : (
                            <CustomTextField
                              placeholder={
                                isCustomerServiceForm
                                  ? "Client's Name"
                                  : "Your Name"
                              }
                              id="userName"
                              name="name"
                              validation={{
                                values,
                                setFieldValue,
                                touched,
                                errors,
                              }}
                              otherProps={{
                                onChange: (event) => {
                                  setFieldValue("name", event.target.value);
                                },
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      className="textbox-icons"
                                      src={account}
                                      alt="account"
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={isAdminHubAssessment ? 6 : 12}
                          lg={isAdminHubAssessment ? 6 : isAdmin ? 6 : 12}
                          className={isAdminHubAssessment ? "" : "p-top-down"}
                        >
                          {isAdminHubAssessment ? (
                            <TextField
                              fullWidth
                              size="small"
                              label="Client's Email"
                              name="email"
                              type="email"
                              value={values.email ?? ""}
                              onChange={(event) =>
                                setFieldValue("email", event.target.value)
                              }
                              onBlur={() => setFieldTouched("email", true)}
                              error={Boolean(touched.email && errors.email)}
                              helperText={touched.email && errors.email}
                            />
                          ) : (
                            <CustomTextField
                              id="emailAddress"
                              name="email"
                              placeholder={
                                isCustomerServiceForm
                                  ? "Client's Email"
                                  : "Your Email"
                              }
                              type="email"
                              validation={{
                                values,
                                setFieldValue,
                                touched,
                                errors,
                              }}
                              otherProps={{
                                onChange: (event) => {
                                  setFieldValue("email", event.target.value);
                                },
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      className="textbox-icons"
                                      src={mail}
                                      alt="mail"
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={isAdminHubAssessment ? 6 : 12}
                          lg={isAdminHubAssessment ? 6 : isAdmin ? 6 : 12}
                          className={isAdminHubAssessment ? "" : "p-top-down"}
                        >
                          <CustomPhoneNumberInput
                            name="phone"
                            values={values}
                            touched={touched}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            placeholder="Mobile Phone"
                            otherProps={{
                              id: "phoneNumber",
                              onChange: (event) => {
                                setFieldValue("phone", event);
                                if (!event) {
                                  setFieldValue("phone", "");
                                }
                              },
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={isAdminHubAssessment ? 6 : 12}
                          lg={isAdminHubAssessment ? 6 : isAdmin ? 6 : 12}
                          className={isAdminHubAssessment ? "" : "p-top-down"}
                          sx={
                            hideSearchTypeDropdown
                              ? { display: "none" }
                              : undefined
                          }
                        >
                          {isAdminHubAssessment ? (
                            <FormControl fullWidth size="small">
                              <InputLabel>Property search</InputLabel>
                              <Select
                                label="Property search"
                                value={value}
                                onChange={(event) => {
                                  setValue(event.target.value);
                                }}
                                className="text-start"
                              >
                                <MenuItem value="address">
                                  Search by Address
                                </MenuItem>
                                <MenuItem value="parcel">
                                  Search by Parcel
                                </MenuItem>
                              </Select>
                            </FormControl>
                          ) : (
                            <Select
                              value={value}
                              onChange={(event) => {
                                setValue(event.target.value);
                              }}
                              displayEmpty
                              className="googleAutoComplete mobile-select-tabs w-100 text-start"
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem
                                sx={{
                                  color:
                                    value === "address"
                                      ? "#0395FF"
                                      : "# 0D120B",
                                }}
                                value={"address"}
                              >
                                Search by Address
                              </MenuItem>
                              <MenuItem
                                sx={{
                                  color:
                                    value === "parcel" ? "#0395FF" : "#0D120B",
                                }}
                                value={"parcel"}
                              >
                                Search by Parcel
                              </MenuItem>
                            </Select>
                          )}
                        </Grid>
                        {value === "address" && (
                          <>
                            <Grid
                              item
                              xs={12}
                              md={isAdminHubAssessment ? 6 : 12}
                              lg={isAdminHubAssessment ? 6 : isAdmin ? 6 : 12}
                              className={
                                isAdminHubAssessment ? "" : "p-top-down"
                              }
                            >
                              <Autocomplete
                                className={`googleAutoComplete mw-100 ${
                                  isAdminHubAssessment
                                    ? "admin-hub-risk-form__address"
                                    : ""
                                } ${
                                  touched.address && Boolean(errors.address)
                                    ? "error_border"
                                    : ""
                                }`}
                                name="property"
                                id="propertyAddress"
                                defaultValue={propertyData?.searched_Add || ""}
                                // value={values.address}
                                apiKey={GOOGLE_API_KEY}
                                // onChange={(e) => {
                                //   setFieldValue("address", e.target.value);
                                // }}
                                onPlaceSelected={(address) => {
                                  handleChange(address);
                                }}
                                onBlur={(event) => {
                                  console.log(
                                    "onChange==>",
                                    event.target.value,
                                  );

                                  setFieldValue("address", event.target.value);
                                }}
                                onKeyDown={(event) =>
                                  event.key === "Enter"
                                    ? event.preventDefault()
                                    : null
                                }
                                placeholder={SEARCH_PROPERTY_ADDRESS_FORMAT}
                                options={{
                                  types: ["address"],
                                  componentRestrictions: { country: "us" },
                                }}
                              />
                              {touched.address && Boolean(errors.address) && (
                                <FormHelperText
                                  className="m-0"
                                  sx={{
                                    color: "#d32f2f !important",
                                    maxWidth: "none !important",
                                    fontSize: "12px !important",
                                  }}
                                >
                                  {touched.address && errors.address}
                                </FormHelperText>
                              )}
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={isAdminHubAssessment ? 6 : 12}
                              lg={isAdminHubAssessment ? 6 : isAdmin ? 6 : 12}
                            >
                              {isAdminHubAssessment ? (
                                <TextField
                                  fullWidth
                                  size="small"
                                  label="Unit number"
                                  name="unit_no"
                                  value={values.unit_no ?? ""}
                                  onChange={(event) =>
                                    setFieldValue("unit_no", event.target.value)
                                  }
                                />
                              ) : (
                                <CustomTextField
                                  placeholder="Unit Number"
                                  name="unit_no"
                                  id="unitNumber"
                                  validation={{
                                    values,
                                    setFieldValue,
                                    touched,
                                    errors,
                                  }}
                                  otherProps={{
                                    onChange: (event) => {
                                      setFieldValue(
                                        "unit_no",
                                        event.target.value,
                                      );
                                    },
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <div
                                          style={{
                                            //  opacity: "0.5",
                                            color: "#c3d4cb",
                                          }}
                                        >
                                          <ApartmentIcon />
                                        </div>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              )}
                            </Grid>
                          </>
                        )}
                        {value === "parcel" && (
                          <>
                            <Grid
                              item
                              xs={12}
                              md={isAdminHubAssessment ? 6 : 6}
                              lg={isAdminHubAssessment ? 6 : isAdmin ? 6 : 12}
                              className={
                                isAdminHubAssessment ? "" : "p-top-down"
                              }
                            >
                              {isAdminHubAssessment ? (
                                <TextField
                                  fullWidth
                                  size="small"
                                  label="Parcel number"
                                  name="parcel_number"
                                  value={values.parcel_number ?? ""}
                                  onChange={(event) =>
                                    setFieldValue(
                                      "parcel_number",
                                      normalizeParcelNumber(event.target.value),
                                    )
                                  }
                                  onBlur={() =>
                                    setFieldTouched("parcel_number", true)
                                  }
                                  error={Boolean(
                                    touched.parcel_number &&
                                    errors.parcel_number,
                                  )}
                                  helperText={
                                    touched.parcel_number &&
                                    errors.parcel_number
                                      ? errors.parcel_number
                                      : "Dashes are removed automatically. Leading zeros are optional."
                                  }
                                />
                              ) : (
                                <CustomTextField
                                  placeholder="Parcel Number"
                                  name="parcel_number"
                                  id="parcelNumber"
                                  validation={{
                                    values,
                                    setFieldValue,
                                    touched,
                                    errors,
                                  }}
                                  otherProps={{
                                    onChange: (event) => {
                                      setFieldValue(
                                        "parcel_number",
                                        normalizeParcelNumber(
                                          event.target.value,
                                        ),
                                      );
                                    },
                                  }}
                                />
                              )}
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={isAdminHubAssessment ? 6 : 6}
                              lg={isAdminHubAssessment ? 6 : isAdmin ? 6 : 12}
                              className={
                                isAdminHubAssessment ? "" : "p-top-down"
                              }
                            >
                              <FormControl
                                fullWidth
                                className={
                                  isAdminHubAssessment ? "" : "sign-textField"
                                }
                                htmlFor="demo-customized-textbox"
                                error={
                                  touched.county_code &&
                                  Boolean(errors.county_code)
                                }
                              >
                                <Pracel
                                  className={`${
                                    touched.county_code &&
                                    Boolean(errors.county_code)
                                      ? "error_border"
                                      : ""
                                  }`}
                                  name="county"
                                  id="countySelect"
                                  disableClearable
                                  sx={FieldStyle}
                                  open={open || isCountySearching}
                                  inputValue={countyInput}
                                  filterOptions={(countyOptions) =>
                                    countyOptions
                                  }
                                  noOptionsText={
                                    isCountySearching
                                      ? "Loading counties..."
                                      : countyInput.trim().length >= 2
                                        ? "No counties found"
                                        : "Type at least 2 characters to search counties"
                                  }
                                  onOpen={handleCountyOpen}
                                  onClose={() => {
                                    if (!isCountySearching) {
                                      setOpen(false);
                                    }
                                  }}
                                  onInputChange={handleCountyInputChange}
                                  onChange={(event, newValue) => {
                                    setFieldValue(
                                      "county_code",
                                      String(newValue?.id),
                                    );
                                    setFieldValue(
                                      "county_name",
                                      newValue?.county,
                                    );
                                    setCountyInput(newValue?.county || "");
                                  }}
                                  isOptionEqualToValue={(option, value) =>
                                    option.county === value.county
                                  }
                                  getOptionLabel={(option) =>
                                    option.county || values.county_code
                                  }
                                  options={options}
                                  loading={isCountySearching}
                                  renderInput={(params) => (
                                    <TextField
                                      size={
                                        isAdminHubAssessment
                                          ? "small"
                                          : "medium"
                                      }
                                      label="County"
                                      placeholder="Search the county"
                                      {...params}
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <React.Fragment>
                                            {isCountySearching ? (
                                              <CircularProgress
                                                color="inherit"
                                                size={20}
                                              />
                                            ) : null}
                                            {params.InputProps.endAdornment}
                                          </React.Fragment>
                                        ),
                                      }}
                                    />
                                  )}
                                />
                                {touched.county_code &&
                                  Boolean(errors.county_code) && (
                                    <FormHelperText
                                      sx={{ color: "#d32f2f !important" }}
                                    >
                                      {touched.county_code &&
                                        errors.county_code}
                                    </FormHelperText>
                                  )}
                              </FormControl>
                            </Grid>
                          </>
                        )}
                      </Grid>

                      <Stack
                        py={1}
                        direction={{
                          md: "column",
                          // sm: "column-reverse",
                          // xs: "column-reverse",
                        }}
                        spacing={1}
                        justifyContent={{
                          // md: `${is_PRM ? "center" : "space-between"}`,
                          sm: "start",
                          // xs: "center",
                        }}
                        alignItems={{
                          md: "start",
                          // sm: "center",
                          // xs: "center",
                        }}
                        color={"black"}
                      >
                        <div className="mt-2">
                          {/* <Stack
                            direction={"row"}
                            spacing={1}
                            justifyContent={"flex-start"}
                            alignItems={"start"}
                            color={"black"}
                          >
                            <span className="py-1">
                              <CustomizedCheckbox onChecked={onCheckedTerms} />
                            </span>
                            <span className="pt-1 text-start">
                              I agree to the{" "}
                              <a
                                href={`${DEFAULT_URL}api/service_agreement_2023.pdf`}
                                target={"_blank"}
                                rel="noreferrer"
                              >
                                Terms and Conditions
                              </a>
                            </span>
                          </Stack> */}
                          {!isAdmin && (
                            <Stack
                              direction={"row"}
                              spacing={1}
                              justifyContent={"flex-start"}
                              alignItems={"start"}
                              color={"black"}
                            >
                              <span className="py-1">
                                <CustomizedCheckbox
                                  onChecked={onCheckedAcknowledge}
                                />
                              </span>
                              {acknowledgeMsg ? (
                                acknowledgeMsg
                              ) : (
                                <span className="pt-1 text-start">
                                  I acknowledge that an EquityProtect Fraud
                                  Specialist may contact me regarding my
                                  property risk assessment. I agree to receive
                                  calls and text messages related to my property
                                  assessment, fraud alerts, and protection
                                  services. Msg & data rates may apply.
                                </span>
                              )}
                            </Stack>
                          )}
                          {!isAdmin && onSubmitClick
                            ? (!checkTerms || !checked1) && (
                                <span className="py-3 fw-500 terms_error">
                                  You must agree to the terms and conditions to
                                  proceed.
                                </span>
                              )
                            : null}
                        </div>

                        {!isAdmin && (
                          <Button
                            type="submit"
                            className={`button1 success_popup_btn mt-4 button_width
                          }`}
                            variant="contained"
                          >
                            {host_path?.includes("Equity-Guard")
                              ? "Get Free Title Monitoring"
                              : Btn_Text}
                          </Button>
                        )}
                        {isBackButton && (
                          <div className="text-center w-100">
                            <Button
                              className="text-center m-0 fw-600 text-primary"
                              onClick={() => setIsRiskFormVisible(false)}
                            >
                              Back to Login form
                            </Button>
                          </div>
                        )}
                        {/* {host_path?.includes("Equity-Guard") && (
                          <p
                            className="text-danger text-center fw-700"
                            style={{ padding: "2px 4%" }}
                          >
                            Look up Your Address Started with an Address Lookup
                            & Free Risk Report
                          </p>
                        )} */}
                      </Stack>
                      {isCustomerServiceForm && (
                        <Button
                          type="submit"
                          variant="contained"
                          className="admin-hub-action-btn mt-4"
                          sx={{ width: "100%" }}
                        >
                          Run Risk Assessment
                        </Button>
                      )}

                      {!isCustomerServiceForm && !is_PRM && (
                        <Typography
                          component="p"
                          className="text-center mt-3 mb-0"
                          sx={{ fontSize: "14px", color: "text.secondary" }}
                        >
                          Having trouble?{" "}
                          <Button
                            type="button"
                            variant="text"
                            onClick={handleClick}
                            sx={{
                              p: 0,
                              minWidth: "auto",
                              fontSize: "14px",
                              textTransform: "none",
                              verticalAlign: "baseline",
                              color: "secondary.main",
                              "&:hover": { textDecoration: "underline" },
                            }}
                          >
                            Contact support
                          </Button>
                        </Typography>
                      )}
                    </Form>
                    <ContactPopover />
                  </>
                );
              }}
            </Formik>
          </>
        ) : (
          <Box className="text-center">
            <Box className="">
              <img className="popup_icon border-none" src={Success} alt="" />
              <Typography className="text-center heading_msg py-2">
                Your report is on its way
              </Typography>
              <Typography className="text-center caption_texts fw-400 m-0 pb-3">
                Please check the email address you provided for your free
                report.
              </Typography>
              <Box className="msg_blocks">
                <Typography className="text-center caption_texts fw-400 m-0 ">
                  Should your property appear at risk, please contact our 100%
                  US-based agents or call us right now at:
                </Typography>
                <Typography className="text-center phone_text fw-400 m-0 pt-3">
                  {UCC_FILLER_PHONE_FORMAT}
                </Typography>
              </Box>
              <Box className="mt-5 alert-modal-btn">
                <Button
                  className="button1 success_popup_btn  "
                  onClick={runAnotherReport}
                >
                  Run another report
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Box>

      {is_PRM && !isTailwindComponent && !isCustomerServiceForm && (
        <>
          <Divider orientation="horizontal" />
          <Stack
            direction={"row"}
            justifyContent="center"
            paddingX={2}
            paddingBottom={isFormSubmit ? 0 : 2}
            paddingTop={1}
          >
            {/* <img src={help_center} alt="help_center" className="me-1" /> */}
            <span className="me-1 text-dark">Having trouble?</span>
            <CallUsNow
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              renderText={
                <span
                  className="text-blue text-decoration-none"
                  style={{ cursor: "pointer" }}
                >
                  Contact support
                </span>
              }
            />{" "}
          </Stack>
          {isFormSubmit && (
            <Stack
              direction={"row"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              className=" pt-2"
              paddingBottom={1}
              sx={{}}
            >
              <a
                href={INSTAGRAM_LINK}
                target="_blank"
                rel="noreferrer"
                className="px-2"
              >
                <img
                  src={Instagram_Icon}
                  alt="Facebook"
                  style={{ height: "35px" }}
                />
                {/* <InstagramIcon style={{ color: "#E4405F" }} fontSize="large" /> */}
              </a>

              <a
                href={FACEBOOK_LINK}
                target="_blank"
                rel="noreferrer"
                className="px-2"
              >
                <img
                  src={Facebook_Icon}
                  alt="Facebook"
                  style={{ height: "35px" }}
                />
                {/* <FacebookIcon fontSize="large" /> */}
              </a>
            </Stack>
          )}
        </>
      )}

      <Dialog
        open={Boolean(protectionConfirmation)}
        onClose={cancelProtectedAssessment}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Property already protected</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            This property is already protected by EquityProtect. Would you still
            like to run a Risk Assessment?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={cancelProtectedAssessment}
            disabled={riskManagementLoader}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={proceedWithProtectedAssessment}
            disabled={riskManagementLoader}
          >
            {loanProtectionConfirmation ? "Continue" : "Run assessment"}
          </Button>
        </DialogActions>
      </Dialog>

      {getObjLength(riskManagementData) &&
        !riskManagementData?.success &&
        !protectionConfirmation && (
          <AlertDialog
            isTailwindComponent={isTailwindComponent}
            type="Error"
            openPopup={true}
            onClose={true}
            onCloseFun={() => {
              dispatch(
                propertyRiskManagementAction.fetchPropertyRiskManagementData(
                  {},
                ),
              );
            }}
            mesage={
              <>
                {riskManagementData?.data?.message}
                {riskManagementData?.data?.errors?.contact_support && (
                  <ContactSupport hideMsg={true} spacing={"pt-3"} />
                )}
              </>
            }
            footer={false}
          />
        )}

      <PropertyLocateRecoveryDialog
        open={
          getObjLength(propertyLoanAmountData) &&
          !propertyLoanAmountData?.success &&
          !loanProtectionConfirmation
        }
        isTailwindComponent
        searchType={value}
        errorCode={
          propertyLoanAmountData?.errors?.error_code ||
          propertyLoanAmountData?.data?.error_code
        }
        onTryAgain={clearLocateErrorAndFocus}
      />

      {getObjLength(propertyLoanAmountData) &&
        propertyLoanAmountData?.success && (
          <DialogBox
            width={"md"}
            contentClassName={
              isAdminHubAssessment
                ? "admin-hub-loan-modal__content admin-compact-form"
                : "bg-white"
            }
            dialogParentClass={
              isAdminHubAssessment ? "admin-hub-loan-modal" : ""
            }
            closeButtonClass={
              isAdminHubAssessment ? "admin-hub-loan-modal__close" : ""
            }
            openPopup={propertyLoanAmount}
            // setOpenPopup={setClosingAdminPopup}
            onClose={handlePropertyLoanAmountModal}
            content={
              <LoanProgram
                isTailwindComponent={isTailwindComponent}
                isAdminHubAssessment={isAdminHubAssessment}
                propertyLoanAmountData={propertyLoanAmountData}
                generateReport={generateRiskReport}
              />
            }
          />
        )}

      {source === "Admin" && !isAdminHubAssessment ? (
        <Loader open={riskManagementLoader || userLoginLoader} />
      ) : (
        <RiskAssesmentLoader open={riskManagementLoader || userLoginLoader} />
      )}
    </Box>
  );
};

export default PropertyRiskManagementForm;
